import {
  Box,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid2 as Grid,
  TextField,
  Typography,
} from "@mui/material";
import useCreateForm from "./useCreateForm";
import { AdmCreateRequestDto } from "@/dto/AdmDto";
import { FormProvider } from "react-hook-form";
import { SaveButton, Admins } from "@/organism";

export type CreateFormProps = {
  onSubmit: (data: AdmCreateRequestDto) => void;
  isLoading?: boolean;
};

export const CreateForm = (props: CreateFormProps) => {
  const { onSubmit, isLoading } = props;
  const { methods, handleSubmit } = useCreateForm(onSubmit);

  return (
    <FormProvider {...methods}>
      <Box display={"flex"} flexDirection={"column"} gap={4}>
        <Box>
          <Typography variant={"h6"} sx={{ mb: 2 }}>
            관리자 정보
          </Typography>
          <Grid container columnSpacing={2} rowGap={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <FormLabel required>관리자 아이디</FormLabel>
                <TextField
                  fullWidth
                  type="text"
                  variant="outlined"
                  color="primary"
                  size="small"
                  placeholder="관리자 아이디를 입력해주세요."
                  {...methods.register("admId")}
                  error={!!methods.formState.errors.admId}
                  helperText={methods.formState.errors.admId?.message}
                />
              </FormControl>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              display={{ xs: "none", md: "block" }}
            />
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <FormLabel required>비밀번호</FormLabel>
                <TextField
                  fullWidth
                  type="password"
                  variant="outlined"
                  color="primary"
                  size="small"
                  placeholder="비밀번호를 입력해주세요."
                  {...methods.register("pwd")}
                  error={
                    !!methods.formState.errors.pwd ||
                    !!methods.formState.errors.pwdConfirm
                  }
                  sx={{ mb: 1 }}
                />
                <TextField
                  fullWidth
                  type="password"
                  variant="outlined"
                  color="primary"
                  size="small"
                  placeholder="비밀번호 확인을 입력해주세요."
                  error={
                    !!methods.formState.errors.pwd ||
                    !!methods.formState.errors.pwdConfirm
                  }
                  {...methods.register("pwdConfirm")}
                />
                <FormHelperText
                  error={
                    !!methods.formState.errors.pwd ||
                    !!methods.formState.errors.pwdConfirm
                  }
                >
                  {methods.formState.errors.pwd?.message ||
                    methods.formState.errors.pwdConfirm?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              display={{ xs: "none", md: "block" }}
            />
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <FormLabel required>관리자 이름</FormLabel>
                <TextField
                  fullWidth
                  type="text"
                  variant="outlined"
                  color="primary"
                  size="small"
                  placeholder="관리자 이름을 입력해주세요."
                  {...methods.register("admNm")}
                  error={!!methods.formState.errors.admNm}
                  helperText={methods.formState.errors.admNm?.message}
                />
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <FormLabel required>이메일</FormLabel>
                <TextField
                  fullWidth
                  type="email"
                  variant="outlined"
                  color="primary"
                  size="small"
                  placeholder="이메일을 입력해주세요."
                  {...methods.register("email")}
                  error={!!methods.formState.errors.email}
                  helperText={methods.formState.errors.email?.message}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        <Box>
          <Typography variant={"h6"} sx={{ mb: 2 }}>
            권한 정보
          </Typography>
          <Grid container columnSpacing={2} rowGap={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <FormLabel required>관리자 권한</FormLabel>
                <Admins.AuthSelect
                  {...methods.register("admAuth")}
                  error={!!methods.formState.errors.admAuth}
                />
                <FormHelperText error={!!methods.formState.errors.admAuth}>
                  {methods.formState.errors.admAuth?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box
          display={"flex"}
          alignContent={"center"}
          width={"100%"}
          justifyContent={"center"}
          mt={10}
        >
          <SaveButton onClick={handleSubmit}>
            {isLoading ? "저장 중..." : "저장"}
          </SaveButton>
        </Box>
      </Box>
    </FormProvider>
  );
};
